import { render, staticRenderFns } from "./Checkboxes.vue?vue&type=template&id=6e2e0388"
import script from "./Checkboxes.vue?vue&type=script&lang=ts"
export * from "./Checkboxes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports